var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',_vm._b({staticStyle:{"width":"100%"},attrs:{"stripe":""}},'el-table',{ ..._vm.$props, ..._vm.$attrs },false),_vm._l((_vm.columnGetter),function({ key, label, prop }){return _c('el-table-column',{key:key,attrs:{"prop":prop,"label":label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }